import type { SVGProps } from 'react';
const SvgCreateChart = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <desc>{'Create Chart Streamline Icon: https://streamlinehq.com'}</desc>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M23.25 21.25c0 1.1-.9 2-2 2H2.75c-1.1 0-2-.9-2-2V2.75c0-1.1.9-2 2-2h18.5c1.1 0 2 .9 2 2z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M7.45 18.45c0 .6-.4 1-1 1h-1c-.6 0-1-.4-1-1v-2.8c0-.6.4-1 1-1h1c.6 0 1 .4 1 1zM13.45 18.45c0 .6-.4 1-1 1h-1c-.6 0-1-.4-1-1V6.65c0-.6.4-1 1-1h1c.6 0 1 .4 1 1zM19.45 18.45c0 .6-.4 1-1 1h-1c-.6 0-1-.4-1-1v-6.8c0-.6.4-1 1-1h1c.6 0 1 .4 1 1z"
    />
  </svg>
);
export default SvgCreateChart;
